export default {
  get_news: (state) => state.news.items,
  get_news_pages: (state) => state.news.pages,
  get_unread_news_count: (state) => state.news?.entity?.total_unread,
};
